import BaseMapConfig from "./BaseMapConfig.js";

/**
 * SVG-based map subclass
 */
export default class SvgMap extends BaseMapConfig {
    constructor(containerId, center, zoom) {
        super(containerId, center, zoom);
    }

    /**
     * Add a cadastre parcel using SVG renderer and pattern defs
     */
    async addCadastre({ code_insee, section, numero, surface, commentaire, status, nature_de_la_terre, donnees_api_cadastre }) {
        // Ensure GeoJSON parsed
        let data = donnees_api_cadastre;
        if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch { console.error('JSON parse error'); return; }
        }
        if (!data.features?.length) return;

        // Create unique pattern ID if needed
        const baseStyle = {
            color: nature_de_la_terre?.value ? this._getColor(nature_de_la_terre.value) : '#000',
            fillColor: nature_de_la_terre?.value ? this._getFill(nature_de_la_terre.value) : 'rgba(0,0,0,0.3)',
            weight: 2, opacity: 1, fillOpacity: 1
        };

        const layer = L.geoJSON(data, {
            renderer: L.svg(),
            style: (f) => baseStyle,
            onEachFeature: (f, lyr) => {
                lyr.on('add', () => {
                    if (status?.value === 'locataire') {
                        const uid = `pattern-${this.stringHash(`${code_insee}-${section}-${numero}`)}`;
                        // Insert <pattern> if not exists
                        if (!document.getElementById(uid)) {
                            const svgEl = document.querySelector('.leaflet-map-pane svg');
                            svgEl.insertAdjacentHTML('afterbegin', `
                            <defs>
                            <pattern id="${uid}" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(20)">
                                <rect width="8" height="8" fill="${baseStyle.fillColor}" />
                                <line x1="0" y1="0" x2="0" y2="8" stroke="${baseStyle.color}" stroke-width="2" />
                            </pattern>
                            </defs>`);
                        }
                        const path = lyr.getElement();
                        path.setAttribute('fill', `url(#${uid})`);
                    }

                    const svgPastille = document.querySelector(`.svgpastille.${nature_de_la_terre?.value}`).outerHTML; 

                    // Bind popup
                    const content = `
                        <h3 class="text-xl">Parcelle ${code_insee}-${section}-${numero}</h3>
                        <p class="text-base">${commentaire || ''}</p>
                        <ul>
                            <li class="text-base"><strong>Surface:</strong> ${surface || 'N/A'} ha</li>
                            <li class="text-base"><strong>Statut:</strong> ${status?.label || 'N/A'}</li>
                            <li class="text-base flex gap-1">
                                <strong class="block">Nature: </strong>
                                <div class="flex gap-1">
                                    ${svgPastille}
                                    ${nature_de_la_terre?.label || 'N/A'}
                                </div>
                            </li>
                        </ul>`;
                    lyr.bindPopup(content);
                });
            }
        }).addTo(this.map);

        this.boundsGlobal.extend(layer.getBounds());
    }

    _getColor(key) {
        const C = { bati: 'rgba(227, 205, 39,1)', bois: 'rgba(133, 52, 147,1)', herbage: 'rgba(52, 147, 76,1)', labour: 'rgba(150, 100, 60,1)', marais: 'rgba(17, 153, 188,1)', autre: 'rgba(209, 123, 37,1)' };
        return C[key] || '#000';
    }
    _getFill(key) {
        const C = { bati: 'rgba(227, 205, 39,0.3)', bois: 'rgba(133, 52, 147,0.3)', herbage: 'rgba(52, 147, 76,0.3)', labour: 'rgba(150, 100, 60,0.3)', marais: 'rgba(17, 153, 188,0.3)', autre: 'rgba(209, 123, 37,0.3)' };
        return C[key] || 'rgba(0,0,0,0.3)';
    }
}